import { IBaseMessage, IMessage, IMessageOptions } from './interfaces/IMessages'

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const isValidBase64Image = (url: string) => {
  const base64Regex = /^data:image\/(png|jpg|jpeg|gif);base64,/
  return base64Regex.test(url)
}

export const isLink = (word: string) => {
  return word == '<bss-app-url>'
}

export const uniqueId = () => Math.round(Date.now() * Math.random())

export const isBotMessage = (message: IMessage) => message.type === 'bot'

export const isUserMessage = (message: IMessage) => message.type === 'user'

export const createChatMessage = (message: string, type: string): IBaseMessage => ({ message, type, id: uniqueId() })

export const createChatBotMessage = (message: string, options: IMessageOptions): IMessage => ({
  ...createChatMessage(message, 'bot'),
  ...options,
  loading: true,
})

export const createClientMessage = (message: string, options: IMessageOptions): IMessage => {
  return { ...createChatMessage(message, 'user'), ...options }
}
